import { useMemo } from "react";
import useSWR from "swr";

import {
  listProductTypes,
  listProvisionTypes,
  PRODUCT_TYPES_KEY,
  PROVISION_TYPES_KEY,
  type Category,
} from "@/features/categories/api/categoriesApi";
import { toErrorMessage } from "@/lib/swr";

const EMPTY: Category[] = [];

function useCategoryList(key: string, fetcher: () => Promise<Category[]>) {
  const { data, error, isLoading } = useSWR(key, fetcher);
  const categories = data ?? EMPTY;

  const nameOf = useMemo(() => {
    const byCode = new Map(categories.map((category) => [category.code, category.name]));
    return (code?: string | null) => (code ? (byCode.get(code) ?? "Autre") : "Autre");
  }, [categories]);

  return { categories, nameOf, isLoading, error: toErrorMessage(error) };
}

export function useProvisionCategories() {
  return useCategoryList(PROVISION_TYPES_KEY, listProvisionTypes);
}

export function useProductCategories() {
  return useCategoryList(PRODUCT_TYPES_KEY, listProductTypes);
}
